module.exports = __webpack_public_path__ + "img/video-abstraction.10fc51a8.png";